import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useEffect } from 'react';


const StyledMenu = styled((props: MenuProps) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 10,
        marginTop: theme.spacing(1),
        minWidth: 180,
    },
}));

export interface IDropDownTabOptions {
    id: number;
    value: string;
}
interface IProps {
    items: IDropDownTabOptions[];
    onChange?: (tabId: number) => void;
}

export const OptionsSelectDropdown = (props: IProps) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [tabName, setTabName] = React.useState<string>('General');

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (newTabName: string, newTabId: number) => {
        setTabName(newTabName);
        setAnchorEl(null);
        props.onChange && props.onChange(newTabId);
    };

    useEffect(() => {
        const handleClickAway = (event: Event) => {
            if (anchorEl && !anchorEl.contains(event.target as Node)) {
                setAnchorEl(null);
            }
        };

        document.addEventListener('click', handleClickAway);
        document.addEventListener('touchstart', handleClickAway);

        return () => {
            document.removeEventListener('click', handleClickAway);
            document.removeEventListener('touchstart', handleClickAway);
        };
    }, [anchorEl]);

    return (
        <div>
            <Button
                id="button"
                aria-controls={open ? 'menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant="contained"
                disableElevation
                onClick={handleClick}
                endIcon={<KeyboardArrowDownIcon />}
            >
                {tabName}
            </Button>
            <StyledMenu
                id="menu"
                MenuListProps={{
                    'aria-labelledby': 'button',
                }}
                anchorEl={anchorEl}
                open={open}
            >
                {props.items.map((item) => (
                    <MenuItem
                        key={item.id}
                        value={item.value}
                        onClick={() => handleClose(item.value, item.id)}
                    >
                        {item.value}
                    </MenuItem>
                ))}
            </StyledMenu>
        </div>
    );
};
